<template>
  <div class="home-page cg-page">
    <!-- <Header></Header> -->
    <div class="pt20">
      <a class="logo" href="/"><img src="static/images/logo-new.png" /></a>
    </div>
    <div class="content">
      <div class="drop-down-content">
        <div class="login-content">
          <div class="ac fs33 pt20" style="width:80%;margin:30px auto 30px;color:#ffc497;text-transform: uppercase;" v-html="$t('cgtips1')"></div>
          <div class="ac" style="color:#ffc497;width:80%;margin:0 auto 40px;">{{$t('cgtips2')}}</div>

<!--          <div class="check" style="width:85%;margin:0 auto 40px;text-align: center">-->
<!--            (၂၆.၇.၂၀၂၅) ရက်နေ့မှ (၂၅.၈.၂၀၂၅) ရက်နေ့ အတွင်း စာရင်းပေးသွင်းသူများအတွက် (၁) ပတ်အခမဲ့ ဝန်ဆောင်မှုရရှိနိုင်ပါပြီ-->
<!--          </div>-->

          <div class="ac mt100">
            <button class="btn btn-blue" style="width:70%;" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b mt100">
            {{$t('cgtips3')}}
            <router-link class="fs33 opt-a " :to="{path:'/TC'}">{{$t('TC')}}</router-link>
            {{$t('cgtips4')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        account:'',
        currentTab: 0,
        type:'weekly',
        password:'',

      }
    },
	created(){
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
      switchTab(index) {
        this.currentTab = index;
        this.type = index===1?"daily":"weekly"
      },

		goLogin(){
      const baseUrl = 'http://cl.gameywar.com/gameywar/consent';
      const queryParams = this.$route.query;
      if (Object.keys(queryParams).length > 0) {
        const url = new URL(baseUrl);
        Object.entries(queryParams).forEach(([key, value]) => {
          url.searchParams.append(key, value);
        });
        window.location.href = url.toString();
      } else {
        window.location.href = baseUrl;
      }

		},
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .input{background:#ffc497;height:70px;border:none;border-radius: 20px;font-size:38px;font-family:MyriadProBold;padding:0 20px;width:80%;color: #280933;}
  .input-div{margin:30px 40px 10px;}
  .input-div .span{margin: 0 auto 10px;width:70%;}
  .input-item{background:#ffc497;border-radius: 20px;height:80px;line-height:80px;width:70%;margin: 0 auto;}
  .input-div div span{font-size:38px;padding-left: 30px;color: #280933;}
  .mt100{margin-top:100px;}
  .opt-a{color: #2d31fa;text-decoration: underline;}
  .btn{line-height:80px;background-color:#ffd024;width:100%;color:#280933;}
  .cg-page{background:url(../../static/images/Background.png) no-repeat 0 0 #280933;color:#fff}
  .otp-b a{color:#fff}

  .check{display:flex; align-items:center; justify-content:center; margin-top: 40px}
  .check .item{display:flex; cursor: pointer; padding-left:23px; align-items:center; width:225px; margin:0 15px; border-radius:12px; font-size:24px; line-height:67px; background:#004F9E; color:#fff; text-align:center;}
  .check .item i{display:block; position: relative; margin-right:12px; border:2px solid #fff; width:27px; height:27px;}
  .check .active{background:#FF5353;}
  .check .active i:after{content:'✔'; position:absolute; left:0; top:-10px; font-size:37px; line-height:37px;}
</style>



// WEBPACK FOOTER //
// src/page/Register.vue